module.exports = __webpack_public_path__ + "static/media/R-280HD_CrossSection.da540d6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/es/R-280HD_CrossSection.png
// module id = 486
// module chunks = 0